import { isString } from './genericHelper';


export const GENERIC_ERROR_MESSAGE="An error has occurred. Try to refresh this page. If the error persists please visit our Support page."

/**
 * Make response data into a known structure
 * @param {*} response 
 */
export const structureResponse = (response) => {

    if (response && response.status >= 400) {
        // response is just a string
        if (isString(response?.data)) {
            response.data = {
                error: {
                    message: response.data
                }
            }
        }
    }
}


export const getErrorMessage = (response) =>{
    structureResponse(response)
    return response?.data?.error?.message || GENERIC_ERROR_MESSAGE
}

export const getExceptionMessage = (e) =>{
    return e?.message || GENERIC_ERROR_MESSAGE
}